import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';

const MainContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  /* A flex item's default min-width is its content's: a wide table or a fixed side rail made the whole
     column grow past the window and pushed the right edge of every page out of view. */
  min-width: 0;
  ${css.mobileMedia} {
    width: 100%;
  }
`;

interface MainContentProps {
  children: React.ReactNode;
}

/**
 * Flex column container for the main content area beside the sidebar.
 */
export const MainContent = (props: MainContentProps) => {
  return (
    <MainContentStyled className="main-content">
      {props.children}
    </MainContentStyled>
  );
};
